import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom';
import hourglass from "../../assets/icon/hourglass.gif";
import checkStore from "../../store/checkStore";

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

const SelfCheck = (props: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [view, setView] = React.useState('');
  const [multipleView, setMultipleView] = React.useState(() => []);
  const storeData: any = checkStore();
  const [formats, setFormats] = React.useState(() => ['']);

  useEffect(() => {

    return () => {
    };
  }, []);

  // single select 처리
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setView(newAlignment);
      // 설문조사 항목 선택했을 때, 항목키를 질문번호/답변번호/답변점수로 해놓고 사용
      const askNo = Number(newAlignment.split('/')[0]);
      const answerNo = Number(newAlignment.split('/')[1]);
      const answerPoint = Number(newAlignment.split('/')[2]);

      // 선택한 답변 store에 저장
      let temp = storeData.selectedAnswerList;
      if (temp.length > 0) {
        let existingTemp = temp.filter((v: any) => v.askNo !== askNo);
        if (existingTemp.length > 0) {
          storeData.setSelectedAnswerList(existingTemp.concat({ askNo: askNo, answerNo: answerNo, answerPoint: answerPoint }));
        } else {
          storeData.setSelectedAnswerList([{ askNo: askNo, answerNo: answerNo, answerPoint: answerPoint }]);
        }
      } else {
        storeData.setSelectedAnswerList([{ askNo: askNo, answerNo: answerNo, answerPoint: answerPoint }]);
      }
    }
    window.scroll({ top: 999999, behavior: "smooth" });
  };

  // multiple select 처리
  const handleFormat = (
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ) => {
    setFormats(newFormats);
    const newFormatsExceptionBlank = newFormats.filter((v: any) => v !== '');
    if (newFormats.length > 1) {
      for (let index in newFormatsExceptionBlank) {
        let temp = storeData.selectedAnswerList;
        let existingTemp = temp;
        if (index === '0') {
          existingTemp = temp.filter((v: any) => v.askNo !== Number(newFormatsExceptionBlank[0].split('/')[0]));
        }

        const format = newFormatsExceptionBlank[index];
        const askNo = Number(format.split('/')[0]);
        const answerNo = Number(format.split('/')[1]);
        const answerPoint = Number(format.split('/')[2]);

        // 선택한 답변 store에 저장
        if (temp.length > 0) {
          if (existingTemp.length > 0) {
            storeData.setSelectedAnswerList(existingTemp.concat({ askNo: askNo, answerNo: answerNo, answerPoint: answerPoint }));
          } else {
            storeData.setSelectedAnswerList([{ askNo: askNo, answerNo: answerNo, answerPoint: answerPoint }]);
          }
        } else {
          storeData.setSelectedAnswerList([{ askNo: askNo, answerNo: answerNo, answerPoint: answerPoint }]);
        }
      }
    }
    window.scroll({ top: 999999, behavior: "smooth" });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <Stack flexDirection={'column'} sx={{ bgcolor: '#fff', p: 3 }}>
      <HighlightOffIcon onClick={handleClickOpen}
        sx={{
          color: '#ff736b',
          borderRadius: 2,
          fontSize:35,
          position:'absolute',
          right:8,
          mt:'-15px',
          bgcolor:'#fff'

        }}
      />

      {
        props.item.askType === 'single' ? (

          <Box sx={{ borderRadius: '15px', boxShadow: '0px 0px 3px 0px rgba(0, 0, 0, 0.5)', p: 3, mb: 3 }}>
            <Typography>{props.item.ask}</Typography>
            <ToggleButtonGroup
              orientation="vertical"
              value={view}
              exclusive
              onChange={handleChange}
              sx={{ width: '100%', mt: 2, }}
              className='aaaaaabbbbb'
            >
              {props.item.answer && props.item.answer.map((v: any, index: any) => (
                <ToggleButton value={props.item.askNo + '/' + v.answerNo + '/' + v.answerPoint} sx={toggleBtn}>
                  <Typography>{v.answerTitle}</Typography>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        ) : (
          <Box sx={{ borderRadius: '15px', boxShadow: '0px 0px 3px 0px rgba(0, 0, 0, 0.5)', p: 3, mb: 5 }}>
            <Typography>{props.item.ask + ' (복수선택)'}</Typography>
            <ToggleButtonGroup
              orientation="vertical"
              value={formats}
              onChange={handleFormat}
              sx={{ width: '100%', mt: 2, }}
              className='aaaaaabbbbb'
            >
              {props.item.answer && props.item.answer.map((v: any, index: any) => (
                <ToggleButton value={props.item.askNo + '/' + v.answerNo + '/' + v.answerPoint} sx={toggleBtn}>
                  <Typography>{v.answerTitle}</Typography>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        )
      }

      {props.questionTotalCount === storeData.selectedAnswerList.map((v: any) => v.askNo).filter((v: any, i: any) => storeData.selectedAnswerList.map((v: any) => v.askNo).indexOf(v) === i).length ? (
        <Button startIcon={<ContentPasteSearchIcon />} onClick={() => {
          navigate(props.resultType === 'gauge' ? '/check/SelfScore' : '/check/SelfScoreSimple', {
            state: {
              selfQuestionNo: props.selfQuestionNo,
              selfQuestionOriginalPoint: storeData.selectedAnswerList.reduce((sum: any, item: any) => sum + item.answerPoint, 0),
              resultTitle: props.resultTitle
            }
          });
        }} sx={ResultBtn}>
          결과보기
        </Button>
      ) : (
       null
      )}

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className=''
        sx={{ '& .MuiDialog-paper': { borderRadius: 4 } }}
      >
        <DialogTitle sx={{ m: 0, p: 2, fontSize: 18, fontWeight: 700, textAlign: 'center' }} id="customized-dialog-title">
          그만 진행하시나요?
        </DialogTitle>

        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton> */}

        <DialogContent dividers sx={{ textAlign: 'center' }}>

          <Avatar alt="" src={hourglass} sx={{ width: '100%', height: '100%', '& img': { width: '20%', height: '20%' } }} />
          <Typography sx={{ mt: 2, mb: 1 }}>
            아직 <span>{props.questionTotalCount - storeData.selectedAnswerList.length}</span>개 문항이 남았습니다.
          </Typography>

        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', '&.MuiDialogActions-root': { p: 0, } }}>

          <Button onClick={handleClose} sx={{ flex: 1, bgcolor: '#f0f0f0', p: 2, borderRadius: 0, color: '#444' }}>
            계속진행
          </Button>
          {/* <Divider orientation="vertical" variant="fullWidth" flexItem /> */}
          <Button onClick={() => navigate('/check/SelfCheckList')} sx={{ flex: 1, bgcolor: '#ef8322', p: 2, borderRadius: 0, m: '0 !important', color: '#fff', fontWeight: 700, }}>
            나가기
          </Button>

        </DialogActions>
      </BootstrapDialog>

    </Stack>
  );
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ResultBtn = {
  bgcolor: '#ef8322',
  color: '#fff', 
  borderRadius: 5, 
  mb: 2,
  fontSize:16,
  fontWeight:700,
  '&:hover': {
    border: '1px solid #ef8322', 
    backgroundColor: '#ef8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#ef8322',
    borderColor: '#ef8322',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
}

const toggleBtn = {
  borderRadius: '10px !important',
  border: '1px solid #ccc !important',
  mb: 2,
  '& p' : {fontSize:14, fontWeight:500, color:'#555'},

  '&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected': { 
    border: '1px solid #ffbd9a !important', 
    bgcolor: 'rgb(255 94 0 / 21%) !important', 
    boxShadow: '0 0 5px 3px rgb(255 203 149 / 50%)' },

    '&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected p': { 
      fontWeight:700
    },


  '&.MuiToggleButtonGroup-lastButton': { mb: 0 }
}

export default SelfCheck;